export type Tier = 0 | 1 | 2 | 3 | 4 | 5;

export const tierColors: Record<Tier, string> = {
  0: '#DC2626',
  1: '#E8734A',
  2: '#D97706',
  3: '#C9973A',
  4: '#4A9EB5',
  5: '#22A06B',
};

export const tierOrder: Tier[] = [0, 1, 2, 3, 4, 5];

export function tierLabel(tier: Tier, t: (key: string) => string): string {
  return t('tier.' + tier);
}
